<script lang="ts">
      import { onMount, untrack } from 'svelte'
      import { createLightroomContext } from './ts/Lightroom.svelte'
      import { flipOpacity, renderTick } from '$lib/utils/flip'
      import Back from '../ui/Back.svelte'
      import Forward from '../ui/Forward.svelte'
      import ImageElement from './ImageElement.svelte'
      import VideoElement from '../video/VideoElement.svelte'
      import { render } from 'svelte/server'
      import Close from '../ui/Close.svelte'
      import { Carousel } from './ts/Carousel'
      import { getScrollBlockContext } from '$lib/ui/menu/index.svelte'

      let lightroom = createLightroomContext()

      onMount(() => {
            const ctrl = new AbortController()

            carouselController = new Carousel(lightroomElement, onMove, onMoveEnd)

            carouselController.propagationAllowed = true

            window._lightroom = lightroom

            window.addEventListener(
                  'resize',
                  async () => {
                        resetElement()
                        insertElement()
                        checkSize()
                  },
                  { signal: ctrl.signal }
            )

            return () => {
                  ctrl.abort()
            }
      })

      let moveDelta = 0
      async function onMove(deltaX, deltaY, position) {
            moveDelta += deltaX
            console.log(moveDelta)
      }

      async function onMoveEnd(deltaX, deltaY, position) {
            //moveDelta += deltaX

            if (moveDelta > 100) {
                  lightroom.previous()
                  console.log('moveleft')
            }
            if (moveDelta < -100) {
                  lightroom.next()
                  console.log('moveright')
            }
            moveDelta = 0
      }

      function classChange() {
            if (lightroom.visible) {
                  lightroomElement.classList.add('open')
                  lightroomElement.classList.remove('closed')
            } else {
                  lightroomElement.classList.add('closed')
                  lightroomElement.classList.remove('open')
            }
      }

      async function checkSize() {
            await renderTick()

            if (!lightroomSelectedElement) return
            const parent = lightroomSelectedElement.parentElement
            const element = lightroomSelectedElement.children[0] as HTMLElement
            if (!parent || !element) return
            const parentHeight = parent.getBoundingClientRect().height
            const { height: imageHeight, width: imageWidth } = element.getBoundingClientRect()

            if (parentHeight == 0 || imageHeight == 0) return

            if (imageHeight <= parentHeight) return

            const aspect = imageWidth / imageHeight
            element.style.width = parentHeight * aspect + 'px'
      }

      function resetElement() {
            if (!lightroomSelectedElement) return
            const element = lightroomSelectedElement.children[0] as HTMLElement
            if (!element) return
            element.style.width = '100%'
            lightroomSelectedElement.children[0].innerHTML = ''
      }

      function insertElement() {
            //lightroom.selectedElement?.element.parentElement.append()
            lightroomSelectedElement.children[0].append(lightroom.selectedElement?.element)
      }

      $effect(() => {
            lightroom.selectedElement
            untrack(() => {
                  if (!lightroomSelectedElement.children[0]) return
                  resetElement()
                  insertElement()
                  checkSize()
            })
      })

      $effect(() => {
            lightroom.visible
            untrack(() => {
                  if (_lastVisible == lightroom.visible) return
                  flipOpacity({ element: lightroomElement, flipFn: classChange })
                  _lastVisible = lightroom.visible
                  if (_lastVisible) checkSize()
                  if (lightroom.visible) scrollBlock.requestBodyScrollBlock(lightroomElement)
                  else if (!lightroom.visible) scrollBlock.releaseBodyScrollBlock(lightroomElement)
            })
      })

      const scrollBlock = getScrollBlockContext()

      let _lastVisible = lightroom.visible
      let { children = undefined } = $props()
      let lightroomElement: HTMLElement
      let lightroomSelectedElement: HTMLElement
      let lightroomSlot: HTMLElement

      let carouselController: Carousel
</script>

<div class="hidden"></div>

<div bind:this={lightroomElement} class="fixed fixed-element lightroom-container top-0 left-0 bg-white w-full h-dvh z-[1000] closed items-center justify-between">
      <button
            onclick={() => {
                  lightroom.close()
            }}
            style="z-index: 100;"
            class="w-[3rem] p-3 flex-grow-0 flex-shrink-0 absolute top-0 right-0">
            <Close class="w-full aspect-square fill-black"></Close>
      </button>

      <button onclick={() => lightroom.previous()} class="h-full w-[4rem] p-2 flex-grow-0 flex-shrink-0 hidden md:block">
            <Back class="w-full aspect-square fill-black"></Back>
      </button>

      <div bind:this={lightroomSlot} class="h-[96dvh] w-[98%] mx-auto items-center justify-center">
            <div bind:this={lightroomSelectedElement} class="relative lightroom-element h-full flex items-center justify-center">
                  <div style="width: auto"></div>
            </div>
            <!-- 
           -->
            <!--{#key lightroom.selectedElement}
                  {#if lightroom.selectedElement}
                        <div bind:this={lightroomSelectedElement} class="relative lightroom-element flex items-center justify-center">
                              {#if lightroom.selectedElement.mimeType.match(/image\/.*/)}
                                    <ImageElement image={lightroom.selectedElement} class="w-full h-full object-contain"></ImageElement>
                              {/if}
                              {#if lightroom.selectedElement.mimeType.match(/video\/.*/)}
                                    <VideoElement video={lightroom.selectedElement} class="w-full h-full object-contain aspect-video" autoplay={false} cache={false} muted={false}></VideoElement>
                              {/if}
                        </div>
                  {/if}
            {/key}-->
      </div>

      <button onclick={() => lightroom.next()} class="h-full w-[4rem] p-2 flex-grow-0 flex-shrink-0 hidden md:block">
            <Forward class="w-full aspect-square fill-black"></Forward>
      </button>
</div>

{@render children?.()}

<style lang="postcss">
      @reference "tailwindcss/theme";

      .lightroom-container:global(.open) {
            @apply flex opacity-100;
      }

      .lightroom-container:global(.closed) {
            @apply hidden opacity-0;
      }

      .lightroom-element {
            /*@apply w-full h-auto;*/
      }
      .lightroom-element:global(.tall) {
            /*@apply h-full w-auto;*/
      }

      .lightroom-element :global(> *) {
            @apply rounded-2xl shadow-md overflow-hidden;
      }

      .lightroom-element :global(*) {
            /*@apply w-auto h-auto max-h-[100dvh] ;*/
      }
</style>
